import { css, styled } from 'styled-components';
import { BREAKPOINTS, CUSTOM_WIDTH } from '../../constants/layout.mjs';
import { theme } from '../../constants/theme.mjs';
import { ModalId } from '../../contexts/MenuContext/types.mjs';
import '../Button/index.mjs';
import '../Container/index.mjs';
import { WrapPadding } from '../Container/Container.styles.mjs';
import '../SkeletonLoader/index.mjs';
import '../StyleableSvgImage/index.mjs';
import './CartIcon/index.mjs';
import './MenuItem/index.mjs';
import { Container as Container$1 } from '../Container/Container.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
import { CartIcon as CartIcon$1 } from './CartIcon/CartIcon.mjs';
import { Button } from '../Button/Button.mjs';
import { MenuItem } from './MenuItem/MenuItem.mjs';
import { SkeletonCircleLoader as SkeletonCircleLoader$1 } from '../SkeletonLoader/SkeletonCircleLoader/SkeletonCircleLoader.mjs';
"use strict";
const HEADER_HEIGHT = 48;
const HEADER_GAP_SIZE = 20;
const HEADER_GAP_SIZE_NARROW = 10;
const HEADER_GAP_SIZE_SMALL = 16;
const HEADER_GAP_SIZE_ICONS = 15;
const HEADER_ICON_SIZE = 20;
const HEADER_ACCOUNT_ICON_SIZE = 24;
const HEADER_BUTTON_SIZE = 32;
const cssStickyEmbedHeader = css`
  left: 0;
  position: sticky;
  padding-top: env(safe-area-inset-top);
  right: 0;
  top: 0;
  z-index: ${theme.zIndex.header};

  backdrop-filter: blur(4px);
  background-color: rgb(255 255 255 / 0.9);
`;
const Container = styled(Container$1)`
  @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
    padding: 0;
  }
`;
const Anchor = styled.a`
  text-decoration: none;
`;
const SvgIcon = styled(StyleableSvgImage)``;
const CartIcon = styled(CartIcon$1)``;
const IconWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEADER_BUTTON_SIZE}px;
  width: ${HEADER_BUTTON_SIZE}px;
  cursor: pointer;

  /* Enforce svg color, disabling hover color change */
  ${SvgIcon},
  ${CartIcon} {
    color: ${({
  $motif
}) => theme.colors.menu.text[$motif]};
  }

  &:hover {
    color: ${({
  $motif
}) => theme.colors.menu.active[$motif]};
  }

  ${({
  $hideOnMobile
}) => $hideOnMobile && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
        display: none;
      }
    `}

  ${({
  $hideOnDesktop
}) => $hideOnDesktop && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_UP} {
        display: none;
      }
    `}
`;
const IconsWrap = styled.div`
  display: flex;
  align-items: center;
  margin-left: -6px;
  margin-right: -5px;

  @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
    margin-right: ${HEADER_GAP_SIZE_SMALL - 6}px;
  }
`;
const MenuItemWrap = styled.div`
  display: flex;
  flex-direction: row;
  height: ${HEADER_HEIGHT}px;
  gap: ${({
  $narrow
}) => $narrow ? HEADER_GAP_SIZE_NARROW : HEADER_GAP_SIZE}px;
  margin-left: ${HEADER_GAP_SIZE}px;

  /* HACK hardcoded breakpoint based on actual item widths and spacings */
  @media (max-width: ${CUSTOM_WIDTH.TOP_NAV_DESKTOP_COMPACT}px) {
    gap: ${HEADER_GAP_SIZE_SMALL}px;
    margin-left: ${HEADER_GAP_SIZE_SMALL}px;
  }

  ${({
  $hideOnMobile
}) => $hideOnMobile && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
        display: none;
      }
    `}
`;
const MenuItemLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
const LogoIconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: ${HEADER_HEIGHT}px;
  color: ${({
  $motif
}) => theme.colors.menu.text[$motif]};

  ${({
  $burger
}) => $burger && css`
      margin: 0 ${HEADER_GAP_SIZE_SMALL}px;
    `}
`;
const SiteTitleWrap = styled.div`
  align-items: center;
  color: #212327;
  display: flex;
  font-size: 20px;
  font-weight: 700;
  height: ${HEADER_HEIGHT}px;
  line-height: 28px;
  white-space: nowrap;
`;
const ContinueShoppingButton = styled(Button)`
  height: ${HEADER_HEIGHT}px;
  color: #50565e;
  font-size: 12px;
  line-height: ${16 / 12};
  padding: 8px 4px;

  /* Check for hover capability to prevent wrong UI styles of category tabs https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover */
  @media (hover: hover) {
    &:hover {
      color: ${({
  $motif
}) => theme.colors.menu.active[$motif]};
    }
  }
`;
const BackIconWrap = styled.div`
  margin-right: 4px;
`;
const MenuItemsWrap = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;

  /* Not sure why is the overflow hidden here. In one of the storybook cases it caused clipping. */
  /* overflow: hidden; */
`;
const LeftWrap = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;

  ${({
  $static
}) => !$static && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    `}
`;
const ModalWrap = styled(Container)`
  flex: 0;
  margin: 0 auto;
  z-index: ${theme.zIndex.header - 1};

  ${({
  $fullWidth
}) => $fullWidth && css`
      padding: 0;
    `}

  ${WrapPadding} {
    position: relative;
  }
`;
const ModalInnerWrap = styled.div`
  position: absolute;
  top: ${({
  $top
}) => $top ?? 10}px;
  z-index: ${theme.zIndex.modal};

  ${({
  $modal,
  $pro,
  $isLeft
}) => {
  switch ($modal) {
    case ModalId.Support:
      return css`
          right: 106px;
        `;
    case ModalId.Cart:
    case ModalId.Account:
    case ModalId.CartPreview:
      return css`
          ${$isLeft ? "left" : "right"}: ${$pro ? 0 : 32}px;

          @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
            ${$isLeft ? "left" : "right"}: 10px;
          }
        `;
    default:
      return;
  }
}}
`;
const InnerLeftWrap = styled.div`
  display: flex;
  flex: 1;
  justify-content: ${({
  $center
}) => $center ? "center" : "unset"};
`;
const LinkItem = styled(MenuItem)`
  margin: 0 6px;

  @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
    display: none;
  }
`;
const SearchTabWrap = styled.div`
  display: block;
  width: 100%;
  max-width: 680px;
  margin: 0 8px;

  /**
   * * hack: search tab hidden with opacity ad position, so search input can be referenced (searchInputRef)
   * * and focus can be triggered on the search input onClick
   * @see https://css-tricks.com/comparing-various-ways-to-hide-things-in-css/#aa-method-4-the-position-property
   */
  ${({
  hide
}) => hide && css`
      opacity: 0;
      position: absolute;
      top: -9999px;
      left: -9999px;
    `}
`;
const StorePickerModalWrap = styled.div`
  position: absolute;
  left: 64px;
  top: 50px;
  z-index: ${theme.zIndex.modal};
`;
const SkeletonCircleLoader = styled(SkeletonCircleLoader$1)`
  margin: 0;

  /**
   * * This overrides width that is set by diameter prop.
   * If used and is different than set diameter, the circle might not be perfectly round.
   */
  ${({
  $overrideWidth
}) => $overrideWidth && css`
      width: ${$overrideWidth}px;
    `}
`;
const Wrap = styled.div`
  position: relative;
`;
const HeaderWrap = styled.div`
  position: relative;
  height: ${({
  noWrapHeight
}) => noWrapHeight ? "0" : `${HEADER_HEIGHT}px`};
`;
const Header = styled.header`
  z-index: ${theme.zIndex.header};
  position: ${({
  $sticky
}) => $sticky ? "fixed" : "static"};
  top: 0;
  width: ${({
  $stickyPadding
}) => $stickyPadding ? `calc(100% - ${$stickyPadding})` : "100%"};
  height: ${HEADER_HEIGHT}px;
  background-color: ${({
  $motif,
  $transparent
}) => $transparent ? theme.colors.menu.transparent[$motif] : theme.colors.menu.base[$motif]};

  backdrop-filter: ${({
  $transparent
}) => $transparent ? "blur(4px)" : "none"};

  /* HACK to fix the white border glitch, quick solution */
  box-shadow: 0 0 0 1px
    ${({
  $motif,
  $transparent
}) => $transparent ? "none" : theme.colors.menu.base[$motif]};
`;
const AvatarWrap = styled.div`
  align-items: center;
  border: 1px solid #006fff;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  margin-bottom: 0;
  outline: 1px solid #006fff;
  overflow: hidden;
  width: 24px;
  background: #ededf0;
  border-radius: 50%;

  img {
    height: 24px;
    min-height: 24px;
    min-width: 24px;
    width: 24px;
    object-fit: cover;
  }
`;
const HamburgerButton = styled(MenuItem)`
  width: 52px;

  &&:hover {
    background: none;
  }
`;
const SrContainer = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
export { Anchor, AvatarWrap, BackIconWrap, CartIcon, Container, ContinueShoppingButton, HEADER_ACCOUNT_ICON_SIZE, HEADER_BUTTON_SIZE, HEADER_GAP_SIZE, HEADER_GAP_SIZE_ICONS, HEADER_GAP_SIZE_NARROW, HEADER_GAP_SIZE_SMALL, HEADER_HEIGHT, HEADER_ICON_SIZE, HamburgerButton, Header, HeaderWrap, IconWrap, IconsWrap, InnerLeftWrap, LeftWrap, LinkItem, LogoIconWrap, MenuItemLabel, MenuItemWrap, MenuItemsWrap, ModalInnerWrap, ModalWrap, SearchTabWrap, SiteTitleWrap, SkeletonCircleLoader, SrContainer, StorePickerModalWrap, SvgIcon, Wrap, cssStickyEmbedHeader };
//# sourceMappingURL=Header.styles.mjs.map
